import * as React from 'react'

export const OrdersIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 37.3333C8 35.8606 9.19391 34.6667 10.6667 34.6667H26.6667C28.1394 34.6667 29.3333 35.8606 29.3333 37.3333V53.3333C29.3333 54.8061 28.1394 56 26.6667 56H10.6667C9.19391 56 8 54.8061 8 53.3333V37.3333Z"
        fill="#001C64"
      />
      <path
        d="M21.3305 24C21.3305 22.5272 22.5244 21.3333 23.9972 21.3333H39.9999C41.4727 21.3333 42.6666 22.5272 42.6666 24V39.9997C42.6666 41.4724 41.4727 42.6663 39.9999 42.6663H23.9972C22.5244 42.6663 21.3305 41.4724 21.3305 39.9997V24Z"
        fill="#5BBBFC"
      />
      <path
        d="M34.6667 10.6667C34.6667 9.19391 35.8606 8 37.3333 8H53.3345C54.8072 8 56.0011 9.19391 56.0011 10.6667V26.6665C56.0011 28.1393 54.8072 29.3332 53.3345 29.3332H37.3333C35.8606 29.3332 34.6667 28.1393 34.6667 26.6665V10.6667Z"
        fill="#6FC400"
      />
      <path
        d="M53.3334 11.3333C53.3334 10.9651 53.0349 10.6666 52.6667 10.6666L46.1667 10.6666C45.7985 10.6666 45.5001 10.9651 45.5001 11.3333V12.3333C45.5001 12.7014 45.7985 12.9999 46.1667 12.9999H49.3501L45.1464 17.2036C44.8861 17.4639 44.8861 17.886 45.1464 18.1464L45.8535 18.8535C46.1139 19.1138 46.536 19.1138 46.7963 18.8535L51.0001 14.6498V17.8333C51.0001 18.2014 51.2985 18.4999 51.6667 18.4999H52.6667C53.0349 18.4999 53.3334 18.2014 53.3334 17.8333V11.3333Z"
        fill="#005400"
      />
      <path
        d="M42.6668 29.3332H37.3333C35.8606 29.3332 34.6667 28.1393 34.6667 26.6665V21.3333H39.9999C41.4727 21.3333 42.6666 22.5272 42.6666 24L42.6668 29.3332Z"
        fill="#FAF8F5"
      />
      <path
        d="M29.3333 42.6663H23.9972C22.5244 42.6663 21.3305 41.4724 21.3305 39.9997L21.3307 34.6667H26.6667C28.1394 34.6667 29.3333 35.8606 29.3333 37.3333V42.6663Z"
        fill="#FAF8F5"
      />
    </svg>
  )
})

OrdersIcon.displayName = 'OrdersIcon'
